import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyUnsubscribeWebPushNotifications } from 'owa-webpush-notifications';
import {
    getOptionsForFeature,
    WebPushNotificationsOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import { trace } from 'owa-trace';

const signoutUrl = '/owa/logoff.owa';

export let signout = action('signout')(async function signout(locationObj: Location) {
    if (
        isFeatureEnabled('fwk-webPushNotification') &&
        isFeatureEnabled('fwk-webPushNotificationSignout')
    ) {
        try {
            const webPushNotificationsOptions = getOptionsForFeature<WebPushNotificationsOptions>(
                OwsOptionsFeatureType.WebPushNotifications
            );
            if (webPushNotificationsOptions == null || webPushNotificationsOptions.enabled) {
                const unsubscribe = await lazyUnsubscribeWebPushNotifications.import();
                await unsubscribe(window);
            }
        } catch (error) {
            trace.error('[WebPush] Failed to unsubscribe on signout, error: ' + error);
        }
    }

    const userConfiguration = getUserConfiguration();
    if (userConfiguration.ApplicationSettings.CloseWindowOnLogout) {
        // TODO: Task 644 - Put up message box saying to sign out by closing all windows.
        // Only needed for on-prem
    }

    if ('sessionStorage' in window && window.sessionStorage) {
        window.sessionStorage.clear();
    }

    locationObj.assign(signoutUrl);
});
